import { StopList } from "../StopList";
import { DataSource, HorizontalSpacer, Label, Layout, SaveButton, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCancelStopSelection extends Layout {
    horizontalspacer2: HorizontalSpacer;
    labelSelectingAllStopsWillRollBackAllStopsAndSetTheMovementBackToCovered: Label;
    labelSelectingPartialStopsWillRollBackTheSelectedStopsAndKeepTheMovementInProgress: Label;
    layoutStopList: StopList;
    savebuttonRollback: SaveButton;
    sourceMovement: DataSource;
    textboxId: Textbox;
}
